import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class AccountService {
    static accountExists(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayaccountAccount'),
            'accountExists', [accountNumber], additionalHeaders);
    }

    static  getNotesForAccount (accountNumber,  additionalHeaders = {})  {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayAccount'),
            'getNotesForAccount', [accountNumber],additionalHeaders);
    }

    static createNoteForAccount (accountNumber, noteDTO ,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayAccount'),
            'createNoteForAccount', [accountNumber, noteDTO],additionalHeaders);
    }
}
